// 관리자 첫 화면의 「이번 달 보호자 알림 성공률」 — 배송은 됐는데 문자가 안 간 비율이 서비스 질의 첫 신호(예행연습 08 건강 지표)
import { useEffect, useState } from "react";
import { getCountFromServer, where } from "firebase/firestore";
import { orgQuery } from "@/lib/org";
import { fmtYearMonth } from "@/lib/format";

export default function NotifyRate() {
  const [n, setN] = useState<{ ok: number; fail: number } | null>(null);
  useEffect(() => {
    const ym = fmtYearMonth();
    // 집계 조회(문서를 내려받지 않고 개수만) — 한 달 배송 수천 건이어도 읽기 요금이 거의 안 든다
    Promise.all([
      getCountFromServer(orgQuery("deliveries", where("yearMonth", "==", ym), where("notifyOk", "==", true))),
      getCountFromServer(orgQuery("deliveries", where("yearMonth", "==", ym), where("notifyOk", "==", false))),
    ])
      .then(([a, b]) => setN({ ok: a.data().count, fail: b.data().count }))
      .catch(() => setN(null));
  }, []);
  if (!n || n.ok + n.fail === 0) return null;
  const total = n.ok + n.fail;
  const rate = Math.round((n.ok / total) * 100);
  const tone = rate >= 97 ? "text-emerald-700" : rate >= 90 ? "text-amber-700" : "text-rose-700";
  return (
    <div className="card p-4">
      <div className="text-sm text-slate-500">이번 달 보호자 알림 성공률</div>
      <div className={`text-2xl font-extrabold ${tone}`}>{rate}%</div>
      <div className="text-sm text-slate-500">
        배송 {total.toLocaleString()}건 중 알림 도착 {n.ok.toLocaleString()}건{n.fail ? ` · 못 간 집 ${n.fail.toLocaleString()}곳(위 카드에서 번호 고치기)` : ""}
      </div>
    </div>
  );
}
